import React from 'react';
import { calcPriceImageHardwareFormated } from './PriceTotal.service';
import { UHCSidebarServerContractProps } from '../../../../../Molecules/Server/Contract/Sidebar/Sidebar.interface';
import { PriceContainer, PriceStrong } from './PriceTotal.styled';

export interface UHCPriceTotalProps {
    profileSelected: UHCSidebarServerContractProps['profileSelected'],
    priceStrong?: boolean,
    applyDiscount?: boolean
}

const UHCPriceTotal: React.FC<UHCPriceTotalProps> = ({ profileSelected, priceStrong, applyDiscount = true, ...rest }) => {
    const { hardware, image } = { ...profileSelected };

    const totalPrice = calcPriceImageHardwareFormated(hardware, image, false);
    const memoryPrices = hardware.memory.prices

    if (applyDiscount && memoryPrices.discount && memoryPrices.discount.price > 0 && memoryPrices.discount.period > 0) {
        const totalPriceDiscount = calcPriceImageHardwareFormated(hardware, image, true);
        const labelDiscount = (memoryPrices.discount.period === 1) ? 'no primeiro mês' : `nos primeiros ${memoryPrices.discount.period} meses`
        const labelTotalPrice = `a partir do ${memoryPrices.discount.period + 1}º mês`

        return (
            <PriceContainer data-testid='price-total' {...rest}>
                <PriceStrong strong={priceStrong}>{totalPriceDiscount}</PriceStrong> <small>{labelDiscount}</small> <br />
                <PriceStrong strong={priceStrong}>{totalPrice} </PriceStrong><small>{labelTotalPrice}</small>
            </PriceContainer>
        )
    } else {
        return <PriceContainer data-testid='price-total' {...rest}><PriceStrong className='price-total' strong={priceStrong}>{totalPrice}</PriceStrong>/mês</PriceContainer>
    }
}

export default UHCPriceTotal;